'use client'

import { Fragment } from 'react'
import {
  IconCircleMinus,
  IconCircleX,
  IconPackageImport,
  IconTruckReturn
} from '@tabler/icons-react'

import { SaleOrderReturnStatus } from '../types'

import styles from './ProfileSaleOrderReturnStatusBadge.module.scss'

const statusMessageMap = {
  [SaleOrderReturnStatus.UNAVAILABLE]: null,
  [SaleOrderReturnStatus.AVAILABLE]: 'Możliwy zwrot',
  [SaleOrderReturnStatus.NEW]: 'Zwrot zgłoszony',
  [SaleOrderReturnStatus.IN_PROGRESS]: 'Zwrot w toku',
  [SaleOrderReturnStatus.COMPLETED]: 'Zwrócono',
  [SaleOrderReturnStatus.CANCELLED]: 'Zwrot anulowany',
  [SaleOrderReturnStatus.REJECTED]: 'Zwrot odrzucony'
}

const statusIconMap = {
  [SaleOrderReturnStatus.UNAVAILABLE]: Fragment,
  [SaleOrderReturnStatus.AVAILABLE]: IconTruckReturn,
  [SaleOrderReturnStatus.NEW]: IconTruckReturn,
  [SaleOrderReturnStatus.IN_PROGRESS]: IconTruckReturn,
  [SaleOrderReturnStatus.COMPLETED]: IconPackageImport,
  [SaleOrderReturnStatus.CANCELLED]: IconCircleMinus,
  [SaleOrderReturnStatus.REJECTED]: IconCircleX
}

const ProfileSaleOrderReturnStatusBadge = ({
  status = SaleOrderReturnStatus.UNAVAILABLE
}: {
  status: SaleOrderReturnStatus
}) => {
  const StatusIcon = statusIconMap[status]
  const statusMessage = statusMessageMap[status]

  if (!statusMessage) return null

  return (
    <mark className={styles.badge}>
      <StatusIcon size={16} />
      <span className={styles.statusMessage}>{statusMessage}</span>
    </mark>
  )
}

export default ProfileSaleOrderReturnStatusBadge
